module.exports = __webpack_public_path__ + "media/assets/facebook-white-6fba3e16d3c3655362e927bf22ac20a4.svg";